

























import Vue from 'vue';
import customerClient from '../../../apis';
import customerVuex from '../../../vuex/common';
import moment from 'moment';

const tracesData: any[] = [];
const remarks: any | null = null;

export default Vue.extend({
  mixins: [customerVuex],
  data() {
    return {
      tracesData,
      moment,
      remarks,
      loadRemarked: false,
    };
  },
  methods: {
    loadTraces() {
      customerClient.getTraces({
        openid: this.customerState.currentCustomer!.openid,
        traceTime: '2199-01-01 00:00:00',
        size: 50,
      }).success((r) => {
        const traceData = r.traces;
        for (const i in traceData) {
          traceData[i].contents = Object.values(traceData[i].contents)[0];
        }
        const td = this.transData(traceData);
        if (this.tracesData.length === 0) {
          this.tracesData = td;
        } else {
          this.tracesData = this.tracesData.concat(td);
        }
        this.getRemarks();
      });
    },
    getRemarkText(ids: number[]) {
      return ids.map((id: number) => this.remarks[id]).join('、');
    },
    getRemarks() {
      const tempData = JSON.parse(JSON.stringify(this.tracesData));
      if (tempData.filter((r: any) => r.traces.filter((trace: any) => trace.outerType === 27 && trace.contents.text.length > 0).length > 0).length > 0) {
        const remarkIdsText = tempData.map((r: any) => r.traces.filter((trace: any) => trace.outerType === 27 && trace.contents.text.length > 0).map((r: any) => r.contents.text).join('、')).join('、');
        const remarkIds = remarkIdsText.split('、').filter((id: string) => id.length > 0);
        if (remarkIds.length > 0) {
          customerClient.getRemarksById({
            ids: remarkIds.map((id: string) => parseInt(id)),
          }).success((r) => {
            this.remarks = r;
          }).done(() => {
            this.loadRemarked = true;
          });
        }
      } else {
        this.loadRemarked = true;
      }
    },
    transData(arr: any[]): any[] {
      const newArr: any[] = [];
      arr.forEach((trace, i) => {
        let index = -1;
        const alreadyExists = newArr.some((newTrace: any, j: number) => {
          if (trace.traceDay === newTrace.traceDay) {
            index = j;
            return true;
          } else {
            return false;
          }
        });
        if (!alreadyExists) {
          newArr.push({
            traceDay: trace.traceDay,
            traces: [trace],
          });
        } else {
          newArr[index].traces.push(trace);
        }
      });
      return newArr;
    },
  },
  mounted() {
    this.loadTraces();
  },
});
